export default __webpack_public_path__ + "static/media/cn.d4c3559a.svg";